import {
  FormField,
  StepNumber,
} from '@codev/helix-react';
import PropTypes from 'prop-types';
import React from 'react';
import {
  FormControl,
} from 'react-bootstrap';
import translations from './translations.js';

const Step3 = ({
  language = 'en_US',
  onChange,
  verificationCode,
}) => (
  <StepNumber number={3} style={{marginBottom: 0}}>
    {translations('step3Text', language)}
    <div
      style={{
        display: 'flex',
        marginLeft: '25px',
        marginTop: '15px',
      }}
    >
      <span
        className="tall-form-group"
        style={{
          height: '50px',
          marginRight: '10px',
          marginTop: '5px',
        }}
      >
        <strong>{translations('step3Verification', language)}</strong>
      </span>
      <span>
        <FormField
          className="tall-form-group"
          isRequired
          isRequiredErrorMessage={translations('isRequiredMessage', language)}
          style={{
            height: '50px',
          }}
          validate={[
            () => {
              if (!(new RegExp(/^\d{6}$/).test(verificationCode))) {
                return <span style={{position: 'fixed'}}>{translations('step3VerificationError', language)}</span>;
              }
            }
          ]}
          value={verificationCode}
        >
          <FormControl
            autoFocus
            onChange={(event) => onChange(event.target.value)}
            style={{
              width: '125px',
            }}
            type="text"
            value={verificationCode}
          />
        </FormField>
      </span>
    </div>
  </StepNumber>
);

Step3.defaultProps = {
  verificationCode: '',
};

Step3.propTypes = {
  onChange: PropTypes.func.isRequired,
  verificationCode: PropTypes.string.isRequired,
};

export default Step3;